// @flow
import type { DeviceInfo, DevicePanelInfoProps } from './panel-list/types';
import React, { Component } from 'react';
import AsyncButton from '~/components/widgets/buttons/async';
import DefaultInfoPanelList from './panel-list/default';
import HubInfoPanelList from './panel-list/hub';
import HueBridgeInfoPanelList from './panel-list/hue-bridge';
import messages from './intl';
import { RHSButtonContainer } from '~/components/widgets/buttons/button/styles';
import UnsavedChangesModal from '~/components/widgets/unsaved-changes-modal';
import RemoveDevice from '~/components/widgets/remove-device';

type State = {
    showRemoveModal: boolean
};

export default class InfoPanel extends Component<DevicePanelInfoProps, State> {
    state = {
        showRemoveModal: false
    };

    handleRestartHub = (e: SyntheticEvent<HTMLButtonElement>) => {
        e.preventDefault();

        this.props.restartHub();
    };

    renameDevice = (name: string) => {
        const deviceInfo: DeviceInfo = {
            name,
            productType: this.props.type,
            productId: this.props.id
        };
        this.isZone() ? this.props.renameZone(deviceInfo) : this.props.renameDevice(deviceInfo);
    };

    shouldComponentUpdate(nextProps: DevicePanelInfoProps) {
        return !!nextProps.device;
    }

    isZone = (): boolean => {
        return (
            (this.props.id === this.props.zoneId && typeof this.props.tuiId !== 'undefined') ||
            (typeof this.props.zoneId !== 'undefined' && this.props.id !== this.props.zoneId)
        );
    };

    render() {
        const {
            connectedDevices,
            device,
            fields: { name },
            hasErrored,
            hasRestartingError,
            id,
            isHub,
            isHubSense,
            isHueBridge,
            isRestarting,
            pristine,
            saving,
            serialNumber,
            showRemoveDevice
        } = this.props;

        const isZone = this.isZone();
        const headingIntl = isZone ? messages.zoneNickname : messages.nickname;

        return (
            <form
                className="edit-device"
                onSubmit={(e: SyntheticInputEvent<>) => {
                    e.preventDefault();
                    !name.invalid && this.renameDevice(name.value);
                }}
            >
                <UnsavedChangesModal showModal={!pristine && !name.invalid} />
                {isHueBridge && (
                    <HueBridgeInfoPanelList
                        connectedDevices={connectedDevices}
                        device={device.props}
                        serialNumber={serialNumber}
                    />
                )}
                {isHub && <HubInfoPanelList {...this.props} headingIntl={headingIntl} />}
                {!isHueBridge && !isHub && <DefaultInfoPanelList {...this.props} headingIntl={headingIntl} />}
                {!isHueBridge && (
                    <RHSButtonContainer>
                        <AsyncButton
                            disabled={name.initialValue === name.value || !name.value}
                            error={hasErrored}
                            saving={saving}
                            type="submit"
                        />
                    </RHSButtonContainer>
                )}
                {showRemoveDevice && <RemoveDevice deviceId={id} />}
                {isHubSense && (
                    <RHSButtonContainer>
                        <AsyncButton
                            disabled={isRestarting}
                            error={hasRestartingError}
                            messages={{
                                save: messages.restartHub,
                                saving: messages.restarting
                            }}
                            onClick={this.handleRestartHub}
                            saving={isRestarting}
                        />
                    </RHSButtonContainer>
                )}
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/component.js